<template>
  <div class="navigation__loader" v-if="loading || error">
    <LoadingIndicator />
  </div>
  <div v-if="!loading && !error">
    <div class="navigation-professionals">
      <form @submit.prevent="doSearch">
        <div class="navigation-professionals__filter">
          <Dropdown @update="updateFilters" attribute="location" :options="filterOptions.locations" title="Office" />
        </div>
        <div class="navigation-professionals__filter">
          <Dropdown @update="updateFilters" attribute="practice" :options="filterOptions.practices" title="Practice" />
        </div>
        <div class="navigation-professionals__filter">
          <Dropdown @update="updateFilters" attribute="industry" :options="filterOptions.industries" title="Industry" />
        </div>
        <div class="navigation-professionals__input-wrapper">
          <input type="text" placeholder="Enter name or keyword" name="query" v-model="filters.query" />
          <button title="Search" type="submit">
            <i class="icon-search"></i>
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import axios from "axios";

// Components
import Dropdown from "../FormFields/Dropdown.vue";
import LoadingIndicator from "../../components/Global/LoadingIndicator.vue";

export default {
  components: {
    LoadingIndicator,
    Dropdown,
  },
  data() {
    return {
      error: false,
      loading: true,
      filterOptions: [],
      locations: [],
      services: [],
      filters: {},
    };
  },
  mounted() {
    this.getFilters();
  },
  methods: {
    doSearch: function () {
      let queryparams = new URLSearchParams(this.filters).toString();
      window.location = "/professionals?" + queryparams;
    },
    updateFilters: function (payload) {
      this.filters[payload.attribute] = payload.value;
    },
    getFilters: function () {
      this.loading = true;
      axios
        .post(
          "/api/professionals/filters?culture=en",
          {},
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          this.filterOptions = response.data;
          this.loading = false;
        })
        .catch((err) => {
          this.error = true;
        });
    },
  },
};
</script>
